export var Actions = {
  DECREASE_INITIAL_MONTH: 'DECREASE_INITIAL_MONTH',
  INCREASE_INITIAL_MONTH: 'INCREASE_INITIAL_MONTH',
  DECREASE_FINAL_MONTH: 'DECREASE_FINAL_MONTH',
  INCREASE_FINAL_MONTH: 'INCREASE_FINAL_MONTH',
  CHANGE_YEAR: 'CHANGE_YEAR',
  CHANGE_MONTH: 'CHANGE_MONTH',
  SELECT_DAY: 'SELECT_DAY',
  SELECT_MONTH: 'SELECT_MONTH',
  SELECT_YEAR: 'SELECT_YEAR'
};
export var minYear = new Date(0).getFullYear();
export var maxYear = new Date().getFullYear();
export var MonthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
export var WeekDays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];